<template>

  <DashboardLayout :menu-items="storeDashboardMenu">
    <dashboard-mobile-profile/>

    <div class="text-dashboard  w-100 h-auto">

      <m-update-site-message-1/>

      <h3> دسترسی سریع:</h3>

      <div class="row">


        <b-col lg="4" class="mt-3">
          <router-link class="text-decoration-none" :to="{name:'Profile'}">

            <b-card class="text-center">
              <b-card-title>
                <b-icon icon="emoji-sunglasses"></b-icon>
              </b-card-title>
              <b-card-text>
                پروفایل
              </b-card-text>
            </b-card>
          </router-link>
        </b-col>

        <b-col lg="4" class="mt-3">
          <router-link class="text-decoration-none" :to="{name:'Home'}">

            <b-card class="text-center">
              <b-card-title>
                <b-icon icon="house"></b-icon>
              </b-card-title>
              <b-card-text>
                بازگشت به سایت
              </b-card-text>
            </b-card>
          </router-link>
        </b-col>

        <b-col lg="4" class="mt-3">
          <router-link class="text-decoration-none" :to="{name:'StoreDashboardProducts'}">

            <b-card class="text-center">
              <b-card-title>
                <b-icon icon="shop"></b-icon>
              </b-card-title>
              <b-card-text>
                محصولات
              </b-card-text>
            </b-card>
          </router-link>
        </b-col>

        <div class="mt-5 w-100">
          <Orders/>
        </div>


      </div>

    </div>

  </DashboardLayout>
</template>

<script>
import {mapActions} from 'vuex'
import {storeDashboardMenu} from '@/plugin/routes/DashboardRoutes'
import DashboardLayout from '@/plugin/components/dashboard/Layout'
import Orders from '@/plugin/views/dashboard/orders'
import {walletValue} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";
import WidgetWallet from "@/plugin/components/dashboard/Wallet/WidgetWallet";
import DashboardMobileProfile from "../../../components/dashboard/DashboardMobileProfile";

export default {
  name: "StoreDashboard",
  components: {DashboardLayout, Orders, WidgetWallet, DashboardMobileProfile},
  data() {
    return {
      storeDashboardMenu
    }
  },
  methods: {
    ...mapActions({
      logout: "Authentication/logout"
    }),
    walletValue,
  }

};
</script>

<style scoped>
.text-dashboard {
  width: 95%;
  height: auto;
  background: #fafbf8;
  margin: auto;
  border-radius: 5px;
  padding: 10px;
}

.inventory {
  font-size: 80%;
}

.my-dashboard {
  width: 100%;
  height: 80px;
  background: white;
  border-radius: 5px;
}

.profile-fixed {
  width: 50px;
  height: 50px;
  margin-right: 50px;
}

.text-dashboard {
  width: 95%;
  height: auto;
  background: #fafbf8;
  margin: auto;
  border-radius: 5px;
}

#lblCartCount {
  font-size: 12px;
  background: #ff0000;
  color: #fff;
  padding: 0 5px;
  vertical-align: top;
  margin-left: -10px;
  margin-top: 0px;
}

.bell-big {
  width: 30px;
  height: 20px;
}

.profile-image {
  height: 60px;
  width: 75px;
  object-fit: contain;
}
</style>